import { Component, OnInit, HostListener } from '@angular/core';
import { virtualBetting } from '../../assets/js/virtual-betting';
import { CommonService } from '../../services/commonService';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { altenarPrint } from '../../assets/js/mobilePrint';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { updateBalance } from '../../assets/js/mobilePrint';
import { PrintSlipsComponent } from '../barcode-scanner/print-slips/print-slips.component';
import { JSPM, JSPrintManager, WSStatus, ClientPrintJob, DefaultPrinter } from '../../assets/js/JSPrintManager.js';
import { environment } from '../../environments/environment.prod';
import {  TemplateRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
declare var JsBarcode: any;
@Component({
  selector: 'app-virtual-betting',
  templateUrl: './virtual-betting.component.html',
  styleUrls: ['./virtual-betting.component.css']
})
export class VirtualBettingComponent implements OnInit {
  @ViewChild("responseModel") responseModel: TemplateRef<any>;
  uuid: any;
  errorMessage: string;
  isUserAccess:any;
  sbToken: string = '';
  myScriptElement: HTMLScriptElement;
  mobileView = true;
  betIdArray = [];
  startTimerInterval: any;
  restartTimerInterval: any;
  hideInterval: any;
  printData: any = [];
  newstr: any = [];
  merchantType:string='';
  isAltenarNewScriptEnabled = 'N';
  constructor(public commonService: CommonService, private router: Router, private auth: AuthService, private modalService: NgbModal) {
    JSPrintManager.license_url = environment.baseJSPMLicenseKeyUrl;
    JSPrintManager.auto_reconnect = true;
    JSPrintManager.start();
  }

  ngOnInit() {
    let body = { "dropdown": ["isAltenarNewScriptEnabled","merchants"] }
    document.getElementById('loader').style.display = 'block';
    this.commonService.getDropdownValues(body).subscribe(res => {
      document.getElementById('loader').style.display = 'none';
      if (res.message.errorMessage == "") {
        this.isAltenarNewScriptEnabled = res.list.isAltenarNewScriptEnabled;
        let sportsBettingUrl=res.list.sportsBettingUrl;
        this.merchantType = res.list.merchants[0].id;
        this.getToken(res.list.isAltenarNewScriptEnabled,sportsBettingUrl,this.merchantType);
      }
      else {
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel);
      }
    });
    this.isUserCanAddOrEdit();
    /* this.hideInterval = setInterval(() => {
      let name = 'asb-text'
      let element;
      let doc: any = document.getElementsByClassName(name);
      for (let i = 0; i < doc.length; i++) {
        if (doc[i].innerText == 'MY BETS') {
          element = doc[i].parentElement;
          element.style.display = 'none';
        }
      }
    }) */
    // this.statusTimer();
    fromEvent(window, 'virtual-callback').subscribe((event: any) => {
      // console.log(event);
      if (this.commonService.getClientType() == 'MOBILE') {
        this.alternarPrintData(event.detail);
      }
    })
    const container = document.getElementById('sb2Container');
    if (container) {
      container.style.backgroundColor = 'rgb(171,171,171)';
    }
  }

  ngOnDestroy() {
    window.dispatchEvent(new Event('Destroy-Virtual'));
    clearInterval(this.hideInterval);
    clearInterval(this.startTimerInterval)
    clearInterval(this.restartTimerInterval)
  }

  restartTimer() {
    let className = 'asb-text-center asb-pos-stretch-main _asb_simple-button _asb_simple-button-pointer  _asb_betslip-place-btns-bet ';
    let doc: any = document.getElementsByClassName(className);
    this.restartTimerInterval = setInterval(() => {
      for (let i = 0; i < doc.length; i++) {
        if (doc[i].innerText == 'PLACE BET') {
          this.statusTimer();
          clearInterval(this.restartTimerInterval);
        }
      }
    }, 1000);
  }

  isUserCanAddOrEdit() {
    let body = {
      deviceId: this.uuid,
      clientType: this.commonService.getClientType(),
      clientIp: this.commonService.getClientIP(),
    };
    document.getElementById("loader").style.display = "block";
    this.commonService.getAccessToFintech(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.isUserAccess = res;
      } else {
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  statusTimer() {
    let className = 'asb-pos-stretch-main';
    let status;
    let doc: any = document.getElementsByClassName(className);
    this.startTimerInterval = setInterval(() => {
      /* Print Reciept Button */
      if (this.commonService.getClientType() == 'MOBILE') {
        let printDocName = 'asb-flex-sc _asb_betslip-receipt-header '
        let printDoc: any = document.getElementsByClassName(printDocName);
        for (let i = 0; i < printDoc.length; i++) {
          printDoc[i].style.display = 'none';
        }
      }
      /* Successfully Placed Bet */
      for (let i = 0; i < doc.length; i++) {
        if (doc[i].innerText == 'Accepted') {
          status = doc[i].innerText
          let betId = doc[i].parentElement.firstElementChild.parentElement.previousElementSibling.innerText;
          this.betIdArray.push(betId.split(" ")[2]);
          clearInterval(this.startTimerInterval)
        }
      }
      if (this.betIdArray.length > 0) {
        if (this.commonService.getClientType() == 'MOBILE') {
          this.alternarPrintData(this.betIdArray);
        }
      }
    }, 1000);
  }

  isMobileScreen() {
    let screenWidth = window.innerWidth;
    if (screenWidth < 1030) {
      return true;
    } else {
      return false;
    }
  }
  
  alternarPrintData(betIdArray) {
    let body = {
      "betReferenceNum": betIdArray,
      "type": "BET"
    }
    document.getElementById('loader').style.display = 'block';
    this.commonService.altenarPrint(body,this.merchantType).subscribe(res => {
      document.getElementById('loader').style.display = 'none';
      if (res.message.errorMessage == '') {
        this.printData = res.data;
        if (this.commonService.getClientType() == 'MOBILE') {
          this.restartTimer();
          updateBalance();
          altenarPrint(JSON.stringify(res));
        } else {
          this.restartTimer();
          /* this.printTicketSports(); */
        }
        this.betIdArray = [];
      } else {
        this.betIdArray = [];
      }
    });
  }
  jspmWSStatus() {
    if (JSPrintManager.websocket_status == WSStatus.Open)
      return true;
    else if (JSPrintManager.websocket_status == WSStatus.Closed) {
      alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
      return false;
    }
    else if (JSPrintManager.websocket_status == WSStatus.BlackListed) {
      alert('JSPM has blacklisted this website!');
      return false;
    }
  }

  spaceCount(event, odds) {
    let newEvent = "";
    let newBreak = "";
    let isStop = false;
    for (let i = 0; i < event.length; i++) {
      if (event[i] != ':' && isStop == false) {
        newEvent += event[i];
      } else {
        if (isStop)
          newBreak += event[i];
        else
          newEvent += event[i];
        isStop = true
      }
    }
    newBreak = newBreak.replace(/^\s+/g, '')
    let str = "";
    for (let i = 0; i < 55 - (newBreak.length + odds.length); i++)
      str += " ";
    return [newEvent, newBreak + str + odds];
  }
  gotoPath(name: string) {
    this.router.navigateByUrl(name);
  }
  printTicketSports() {
    if (this.jspmWSStatus()) {
      //Create a ClientPrintJob
      var cpj = new ClientPrintJob();
      //Set Printer type (Refer to the help, there many of them!)

      cpj.clientPrinter = new DefaultPrinter();
      var cmds
      //Data
      this.printData.orderInfo.forEach(element => {
        let events = [];
        for (let event of element.eventList) {
          if (!events.includes(event))
            events.push(event)
        }
        var data = {
          clientName: element.clientName,
          betId: element.betRefrenceNum,
          date: element.transactionDateTime,
          betType: element.betMode,
          barcodeNumber: element.serialNumber,
          stake: element.betAmount,
          odds: element.odds,
          ibCode: element.ibNumber
        }
        //Set content to print...
        //Create ESP/POS commands for sample label
        var esc = '\x1B'; //ESC byte in hex notation
        var newLine = '\x0A'; //LF byte in hex notation

        cmds = esc + "@"; //Initializes the printer (ESC @)
        cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
        cmds += '\x1B' + '\x61' + '\x31' // center align the text
        cmds += esc + '!' + '\x01'; //Character font B selected (ESC ! 1)
        //add the barcode specific code
        cmds += "\x1d\x6b\x4a\x12" + data.betId;
        console.log(cmds);

        cmds += newLine;
        cmds += data.betId;
        cmds += newLine + newLine;
        cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
        cmds += '\x1B' + '\x61' + '\x31' // center align the text
        cmds += 'Bet Details: ';
        cmds += newLine;
        cmds += '\x1B' + '\x61' + '\x30' // left align the text
        cmds += '        Client:       ' + data.clientName;
        cmds += newLine;
        cmds += '        Bet ID:       ' + data.betId;
        cmds += newLine;
        cmds += '        Bet Type:     ' + data.betType;
        cmds += newLine;
        cmds += '        IB:           ' + data.ibCode;
        cmds += newLine;
        cmds += '        Date:         ' + data.date;
        cmds += newLine + newLine;
        cmds += esc + '!' + '\x01'; //Character font B selected (ESC ! 1)
        cmds += 'Event(s)                                         Odds';
        cmds += newLine;

        for (let i = 0; i < events.length; i++) {
          let eventData = this.spaceCount(events[i], data.odds)
          for (let i = 0; i < eventData.length; i++) {
            cmds += eventData[i];
            cmds += newLine;
          }

          cmds += '-----------------------------------------------------';
          cmds += newLine;
        }


        cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
        cmds += newLine;
        cmds += '\x1B' + '\x61' + '\x31' // center align the text
        cmds += 'Total Stake:' + data.stake + '      ';
        cmds += newLine;


        cmds += newLine;
        cmds += newLine;
        cmds += newLine;
        cmds += newLine;
        cmds += newLine;
        cmds += '\x1B' + '\x69';  // to cut the paper
      })

      cpj.printerCommands = cmds;

      //Send print job to printer!
      cpj.sendToClient();
    }
  }

  returnHex(number) {
    var zero = '\x30';
    var one = '\x31';
    var two = '\x32';
    var three = '\x33';
    var four = '\x34';
    var five = '\x35';
    var six = '\x36';
    var seven = '\x37';
    var eight = '\x38';
    var nine = '\x39';

    switch (number) {
      case '0':
        return zero;
      case '1':
        return one;
      case '2':
        return two;
      case '3':
        return three;
      case '4':
        return four;
      case '5':
        return five;
      case '6':
        return six;
      case '7':
        return seven;
      case '8':
        return eight;
      case '9':
        return nine;
      default:
        return zero;
    }
  }

  getToken(key,url,merchantType) {
    document.getElementById('loader').style.display = 'block';
    this.commonService.getAltenarToken(merchantType).subscribe(res => {
      document.getElementById('loader').style.display = 'none';
      if (res.token) {
        this.sbToken = res.token;
        virtualBetting(res.token, key,url,merchantType);

      }
    });

  }

}
